/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Kit 2 React themes
import theme from "assets/theme";
import ConsentPage from "layouts/pages/landing-pages/consent";
import FormRegisterPage from "layouts/pages/landing-pages/form-register";
import ExportRegisterPage from "layouts/pages/landing-pages/export";
import RegisterResultPage from "layouts/pages/landing-pages/form-register-result";
import CallCenterImportRegisterPage from "layouts/pages/landing-pages/callCenter";
import AdminItPage from "layouts/pages/landing-pages/adminIt";
import ReverseCidPage from "layouts/pages/landing-pages/reverse";
import AdminPage from "layouts/pages/admin";

// Material Kit 2 React routes
import routes from "routes";

export default function App() {
  const { pathname } = useLocation();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        {getRoutes(routes)}
        <Route path="/" element={<Navigate to="/ndrs/consent" />} />
        <Route path="/ndrs/form" element={<FormRegisterPage />} />
        <Route path="/ndrs/consent" element={<ConsentPage />} />
        <Route path="/ndrs/export" element={<ExportRegisterPage />} />
        <Route path="/ndrs/result" element={<RegisterResultPage />} />
        <Route path="/ndrs/importCallcenter" element={<CallCenterImportRegisterPage />} />
        <Route path="/ndrs/exportAndImportCallcenter" element={<AdminItPage />} />
        <Route path="/ndrs/reversecid" element={<ReverseCidPage />} />
        <Route path="/ndrs/admin" element={<AdminPage />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </ThemeProvider>
  );
}
